import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const sessionId = new URLSearchParams(search).get("session_id");
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("unknown");
      return;
    }
    let active = true;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
      } catch (e) {
        // keep polling
      }
      if (active) {
        setAttempts((a) => {
          if (a < 15) setTimeout(poll, 2000);
          else setStatus("timeout");
          return a + 1;
        });
      }
    };
    poll();
    return () => {
      active = false;
    };
  }, [sessionId]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-ink px-5 text-center">
      <Logo />
      <div className="mt-12 max-w-md">
        {status === "paid" ? (
          <>
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-forest">
              <svg width="26" height="26" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M2 7.5L5.5 11L12 3" stroke="#1F4D3A" strokeWidth="1.8" strokeLinecap="square" />
              </svg>
            </span>
            <h1 className="mt-8 font-mont text-3xl font-bold text-bone sm:text-4xl" data-testid="payment-success-title">
              Welcome to the cohort.
            </h1>
            <p className="mt-4 font-mont text-sm leading-relaxed text-white/60" data-testid="payment-success-body">
              Payment received. Dani will reach out by email within 48 hours
              with your next steps — keep an eye on your inbox.
            </p>
          </>
        ) : status === "checking" ? (
          <p className="font-mont text-sm uppercase tracking-[0.22em] text-stone" data-testid="payment-checking">
            Confirming your payment…
          </p>
        ) : (
          <>
            <h1 className="font-mont text-2xl font-bold text-bone sm:text-3xl">
              We couldn&rsquo;t confirm your payment yet.
            </h1>
            <p className="mt-4 font-mont text-sm leading-relaxed text-white/60">
              If you completed checkout, your payment went through and Dani
              will confirm by email. You can also reach out on Instagram any
              time.
            </p>
          </>
        )}
        <button
          data-testid="payment-back-home-button"
          onClick={() => navigate("/")}
          className="mt-10 bg-forest px-9 py-4 font-mont text-[12px] font-bold uppercase tracking-[0.22em] text-white transition-colors duration-300 hover:bg-[#2a6b50]"
        >
          Back to the site
        </button>
      </div>
    </div>
  );
}
